import type {} from '@tanstack/react-query';

import { _create } from './Create';
import { _delete } from './Delete';
import { _get } from './Get';
import { _list } from './List';
import { _update } from './Update';

export namespace useSourceSystem {
  export const Get: typeof _get = _get;
  export const List: typeof _list = _list;
  export const Create: typeof _create = _create;
  export const Update: typeof _update = _update;
  export const Delete: typeof _delete = _delete;
}
export { sourceSystemQueryKeys } from './queryKeys';
